(function () {

  // SELECTORS
  const selectors = {
    sidebarSection: '.custom-sidecart-section',
    sidebarContainer: '.custom-sidecart',
    sidebarQty: 'sidecart-qty',
    headerCartButton: '.site-header-cart--button',
    closeSidebarElement: '[data-close-sidebar]',
    orderNoteBlock: '.custom-sidecart-ordernote',
    orderNoteOpen: '.custom-sidecart__ordernote-open',
    orderNoteClose: '[data-close-ordernote]',
    addToSidecart: 'data-add-to-sidecart',
    formError: '.product-form-error',
    removeProduct: 'data-remove-item',
    qtyInput: '[data-quantity-input]',
    qtyInputHalf: '[data-quantity-input-half]',
    qtyInputQuarter: '[data-quantity-input-quarter]'
  };


  // GET SCROLLBAR WIDTH
  let scrollbarWidth = window.innerWidth - document.body.offsetWidth;
  window.addEventListener('resize', () => {
    scrollbarWidth = window.innerWidth - document.body.offsetWidth;
  }, true);


  // OPEN SIDECART
  const openSidebar = (e) => {
    if (e) {
      e.preventDefault();
    }
    document.querySelector('body').classList.add('sidebar-opened');
    document.querySelector(selectors.sidebarSection).classList.add('is-open');
    document.querySelector('html').style.paddingRight = scrollbarWidth + 'px';
  }


  // CLOSE SIDECART
  const closeSidebar = (e) => {
    e.preventDefault();
    document.querySelector('body').classList.remove('sidebar-opened');
    document.querySelector(selectors.sidebarSection).classList.remove('is-open');
    document.querySelector('html').style.paddingRight = 0;
  }


  // SHOW ERROR
  const showError = (el, response) => {
    const errorWrapper = el.closest('div');
    const productFormError = document.querySelector(selectors.formError);
    const isGiftProduct = window.location.href.includes('gift-certificate');
    if (errorWrapper && !productFormError) {
      const formError = document.createElement('p');
      formError.classList.add('product-form-error');
      if (!isGiftProduct) {
        formError.innerHTML = response.description;
        window.location.href = '/cart';
      } else {
        formError.innerHTML = response.message;
      }
      errorWrapper.insertAdjacentElement('afterend', formError);
    } else {
      productFormError.innerHTML = response.description;
    }
  }


  // SHOW/HIDE PRODUCT OVERLAY
  const productOverlay = (item, status) => {
    if (status) {
      item.classList.add('is-loading');
    } else {
      item.classList.remove('is-loading');
    }
  }


  // HELPER: Convert quantity to yardage display text
  const getYardageDisplay = (quantity, isQuarterYard) => {
    if (isQuarterYard) {
      return getQuarterYardDisplay(quantity);
    }
    return quantity + ' yd';
  };

  // HELPER: Convert quantity to quarter-yard fractional display
  const getQuarterYardDisplay = (qty) => {
    const wholeYards = Math.floor(qty / 4);
    const remainder = qty % 4;
    const fractions = ['', '1/4', '1/2', '3/4'];
    if (wholeYards === 0) {
      return (fractions[remainder] || '0') + ' yd';
    }
    if (remainder === 0) {
      return wholeYards + ' yd';
    }
    return wholeYards + ' ' + fractions[remainder] + ' yd';
  };

  // HELPER: Update yardage display element
  const updateYardageDisplay = (thisInput) => {
    const isFabric = thisInput.getAttribute('data-is-fabric') === 'true';
    if (isFabric) {
      const isQuarterYard = thisInput.getAttribute('data-quarter-yard') === 'true';
      const yardageSpan = thisInput.parentNode.querySelector('.sidecart-item-qty__yardage-display');
      if (yardageSpan) {
        yardageSpan.textContent = getYardageDisplay(parseInt(thisInput.value), isQuarterYard);
      }
    }
  };

  // HELPER: Update all yardage displays after cart re-render
  const updateAllYardageDisplays = () => {
    const fabricInputs = document.querySelectorAll('[data-is-fabric="true"]');
    fabricInputs.forEach(input => {
      updateYardageDisplay(input);
    });
  };

  // CHANGE QTY
  const validateAvailableInputQty = (eventType, thisInput) => {{
    if (thisInput.classList.contains('sidecart-item-qty__input')) {
      if (thisInput.value.match(/[^0-9]/g)) {
        thisInput.value = thisInput.value.replace(/[^0-9]/g, '');
      }

      const isFabric = thisInput.getAttribute('data-is-fabric') === 'true';
      const dataMinQty = thisInput.getAttribute('data-min-qty');
      const minQty = isFabric ? (dataMinQty ? Number(dataMinQty) : 1) : 1;
      const maxQty = Number(thisInput.getAttribute('data-max-qty'));
      const currentQty = Number(thisInput.value);

      if (currentQty >= maxQty) {
        thisInput.value = maxQty;
        thisInput.previousElementSibling.removeAttribute('disabled');
        thisInput.nextElementSibling.setAttribute('disabled', 'disabled');
      } else if (currentQty > minQty) {
        thisInput.previousElementSibling.removeAttribute('disabled');
        thisInput.nextElementSibling.removeAttribute('disabled');
      } else if (currentQty <= minQty && maxQty <= minQty) {
        thisInput.previousElementSibling.setAttribute('disabled', 'disabled');
        thisInput.nextElementSibling.setAttribute('disabled', 'disabled');
      } else {
        thisInput.previousElementSibling.setAttribute('disabled', 'disabled');
        thisInput.nextElementSibling.removeAttribute('disabled');
      }

      // Update yardage display for fabric products
      updateYardageDisplay(thisInput);

      if (eventType === 'change') {
        const hasHalfInput = thisInput.parentNode.parentNode.querySelector('[data-quantity-input-half]');
        const hasQuarterInput = thisInput.parentNode.parentNode.querySelector('[data-quantity-input-quarter]');
        
        // Enforce minimum quantity (use dynamic min for fabric)
        if (isFabric && thisInput.value < minQty) {
          thisInput.value = minQty;
          updateYardageDisplay(thisInput);
        } else if (thisInput.value < 1 && !hasHalfInput && !hasQuarterInput) {
          thisInput.value = 1;
        }
        if(thisInput.value < 0 && (hasHalfInput || hasQuarterInput)) {
          thisInput.value = 0;
        }
        setTimeout(() => {
          updateProduct(thisInput.closest('.sidecart-item'));
        }, 300);
      }
    }
  }}

  function handleSideCartChangeQuantity(e) {
    if (e.target.classList.contains('sidecart-item-qty__btn')) {
      const thisInput = e.target.closest('.sidecart-item-qty').querySelector(selectors.qtyInput);
      const isFabric = thisInput.getAttribute('data-is-fabric') === 'true';
      const dataMinQty = thisInput.getAttribute('data-min-qty');
      const minQty = isFabric ? (dataMinQty ? Number(dataMinQty) : 1) : 1;
      const currentQty = Number(thisInput.value);
      
      if (e.target.hasAttribute('data-quantity-minus')) {
        // Prevent going below minimum
        if (currentQty <= minQty) {
          return;
        }
        thisInput.value = currentQty - 1;
      } else if (e.target.hasAttribute('data-quantity-plus')) {
        thisInput.value = currentQty + 1;
      }
      thisInput.dispatchEvent(new Event('change', { 'bubbles': true }));
    }
  }

  function handleSideCartChangeHalfQuantity(e) {
    if(e.target.classList.contains('sidecart-item-qty__dropdown')) {
      const thisInput = e.target.parentNode.querySelector('.sidecart-item-qty').querySelector(selectors.qtyInput);
      thisInput.dispatchEvent(new Event('change', { 'bubbles': true }));
    }
  }

  document.addEventListener('input', (e) => {validateAvailableInputQty('input', e.target)});
  document.addEventListener('change', (e) => {validateAvailableInputQty('change', e.target)});
  document.addEventListener('change', handleSideCartChangeHalfQuantity);
  document.addEventListener('click', handleSideCartChangeQuantity);

  // ADD PRODUCT
  const addProduct = (event) => {
    const thisBtn = event;
    const thisForm = event.closest('[data-product-form]')
    const productFormError = document.querySelector(selectors.formError);
    let config;

    thisBtn.classList.add('is-loading');

    if (productFormError) {
      productFormError.remove();
    }

    if (thisForm) {
      var hcBlocked = null;
      var fundraiserFields = thisForm.querySelectorAll('[data-fundraiser-name]');
      var fundraiserBlocked = null;
      fundraiserFields.forEach(function(inp) {
        var isEmpty = !inp.value || !inp.value.trim();
        inp.setAttribute('aria-invalid', isEmpty ? 'true' : 'false');
        if (isEmpty && !fundraiserBlocked) fundraiserBlocked = inp;
      });
      if (fundraiserFields.length) {
        var fundraiserError = thisForm.querySelector('[data-fundraiser-error]');
        if (fundraiserError) fundraiserError.hidden = !fundraiserBlocked;
      }
      if (fundraiserBlocked) {
        thisBtn.classList.remove('is-loading');
        fundraiserBlocked.focus();
        if (fundraiserBlocked.scrollIntoView) fundraiserBlocked.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      thisForm.querySelectorAll('[data-hc-required]').forEach(function(inp) {
        if (!inp.value || !inp.value.trim()) {
          if (!hcBlocked) hcBlocked = inp;
          var hcField = inp.closest('[data-hc-field]');
          var hcErr = hcField ? hcField.querySelector('[data-hc-error]') : null;
          if (hcErr) { hcErr.style.display = 'block'; }
          if (inp.classList.contains('hc-field__input')) inp.classList.add('hc-input--error');
        }
      });
      // Legacy 24hc-color-selector support
      var hcColorInput = thisForm.querySelector('[data-hc-color-input]');
      if (hcColorInput && hcColorInput.value === '') {
        if (!hcBlocked) hcBlocked = hcColorInput;
        var hcError = thisForm.querySelector('[data-hc-color-error]');
        if (hcError) { hcError.style.display = 'block'; }
      }
      if (hcBlocked) {
        thisBtn.classList.remove('is-loading');
        var hcScrollTarget = hcBlocked.closest('[data-hc-field]') || hcBlocked;
        if (hcScrollTarget.scrollIntoView) hcScrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
    }

    if (thisForm) {
      config = {
        method: 'POST',
        headers: {
          'Accept': `application/javascript`,
          'X-Requested-With': 'XMLHttpRequest'
        }
      };

      const formData = new FormData(thisForm);

      if(formData.has('qty-half')) {
        let newQty = parseFloat(formData.get('quantity') || 1) * 2;
        if(formData.get('qty-half') === '1') {
          newQty += 1;
        }
        const yardsText = window.makeYardAttributeText(formData.get('quantity'), formData.get('qty-half'), 0.5);
        formData.append('properties[Yards]', yardsText);
        formData.append('properties[_time]', Date.now().toString());
        formData.append('properties[_units]', 0.5);
        formData.set('quantity', newQty.toString());
        formData.delete('qty-half');
      }

      if (formData.has('qty-quarter')) {
        let newQty = parseFloat(formData.get('quantity') || 1) * 4;
        if(formData.get('qty-quarter') !== '0') {
          newQty += +formData.get('qty-quarter');
        }
        const yardsText = window.makeYardAttributeText(formData.get('quantity'), formData.get('qty-quarter'), 0.25);
        formData.append('properties[Yards]', yardsText);
        formData.append('properties[_time]', Date.now().toString());
        formData.append('properties[_units]', 0.25);
        formData.set('quantity', newQty.toString());
        formData.delete('qty-quarter');
      }

      formData.append('sections', getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;
    } else if (thisBtn.hasAttribute('data-variant-id')) {
      const productId = thisBtn.getAttribute('data-variant-id');
      config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.headers['Content-Type'] = 'application/json';
      const data = {
        id: productId,
        quantity: 1,
        sections: getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
      };

      if(thisBtn.getAttribute('data-per-yard')) {
        const yardsValue = thisBtn.getAttribute('data-per-yard-units');
        data.properties = {
          _time: Date.now(),
          Yards: yardsValue == 0.25 ? '1/4' : '1/2',
          _units: yardsValue
        };
      }

      config.body = JSON.stringify(data);
    }

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status === 422) {
          showError(thisBtn, response);
          return;
        }
        renderContents(response, true);
        openSidebar();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        window.validateAttributes();
        thisBtn.classList.remove('is-loading');
        if (document.querySelector('body').classList.contains('modal-visible')
          && event.closest('[data-modal-container]')
          && document.querySelector('.allow-scroll-while-locked .modal-close')) {
          document.querySelector('.allow-scroll-while-locked .modal-close').click();
        }
      });
  }


  // UPDATE PRODUCT
  const updateProduct = (event) => {
    const productLine = event.getAttribute('data-line-item');
    const qtyHalfInput = event.querySelector(selectors.qtyInputHalf);
    const qtyQuarterInput = event.querySelector(selectors.qtyInputQuarter);
    let productQty = event.querySelector(selectors.qtyInput).value;

    const config = fetchConfig('javascript');

    const data = {
      line: productLine,
      sections: getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };

    if(qtyHalfInput) {
      const yardsText = window.makeYardAttributeText(productQty, qtyHalfInput.value, 0.5);
      productQty = parseInt(productQty) * 2;
      if(qtyHalfInput.value === "1") {
        productQty += 1;
      }
      data.properties = {
        Yards: yardsText,
        _units: 0.5
      };
    }

    if (qtyQuarterInput) {
      const yardsText = window.makeYardAttributeText(productQty, qtyQuarterInput.value, 0.25);
      productQty = parseInt(productQty) * 4;
      if(qtyQuarterInput.value !== "0") {
        productQty += +qtyQuarterInput.value;
      }
      data.properties = {
        Yards: yardsText,
        _units: 0.25
      };
    }

    data.quantity = productQty;

    config.body = JSON.stringify(data);

    productOverlay(event, true);

    fetch(`${routes.cart_change_url}`, config)
      .then((response) => response.json())
      .then(async (response) => {
        await window.validateAttributes();
        renderContents(response);
        productOverlay(event);
      })
      .catch((e) => {
        console.error(e);
      });
  }


  // REMOVE PRODUCT
  const removeProduct = (event) => {
    const productLine = event.getAttribute('data-line-item');

    productOverlay(event, true);

    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
      line: productLine,
      quantity: 0,
      sections: getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        renderContents(response, true);
      })
      .catch((e) => {
        console.error(e);
      });

  }


  // RENDER CONTENTS
  const fetchConfig = (type = 'json') => {
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
  }

  const renderContents = (parsedState, event = false) => {
    getSectionsToRender().forEach((section => {
      section.selector.forEach((selector) => {
        if (selector !== '#sidecart-related') {
          document.querySelector(selector).innerHTML = getSectionInnerHTML(parsedState.sections[section.id], selector);
        }
        if (selector === '#sidecart-related' && event === true) {
          document.querySelector(selector).innerHTML = getSectionInnerHTML(parsedState.sections[section.id], selector);
        }
      })
    }));

    if (parsedState.item_count === 0 && document.querySelector('.custom-sidecart__related-product')) {
      document.querySelector('.custom-sidecart__related-product').remove();
    }

    const sidecartFooter = document.getElementById('sidecart-footer');
    if (parsedState.item_count === 0) {
      sidecartFooter.classList.add('is-empty');
    } else {
      sidecartFooter.classList.remove('is-empty');
    }

    // Update yardage displays for fabric products after re-render
    updateAllYardageDisplays();
  }

  const getSectionsToRender = () => {
    return [
      {
        id: 'custom-sidecart',
        selector: ['#sidecart-products', '#sidecart-free-shipping', '#sidecart-total-value', '#sidecart-title', '#sidecart-related', '#sidecart-footer']
      },
      {
        id: 'static-header',
        selector: ['.site-header-cart--button']
      }
    ];
  }

  const getSectionInnerHTML = (html, selector = '.shopify-section') => {
    let doc = new DOMParser().parseFromString(html, 'text/html');
    if (!doc.querySelector(selector)) {
      return '';
    }
    return doc.querySelector(selector).innerHTML;
  }


  // INIT SLIDER
  const relatedProductsInit = () => {
    const relatedSlider = new Swiper('.cart-also-like', {
      slidesPerView: 1,
      spaceBetween: 10,
      autoHeight: true,
      navigation: {
        prevEl: ".custom-sidecart__slider-nav-prev",
        nextEl: ".custom-sidecart__slider-nav-next",
      },
    })
  }


  // PRODUCT RECOMMENDATIONS
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            // init "You May Also Like" slider
            relatedProductsInit();
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  window.updateSideCart = function() {
    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
        sections: getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, config)
    .then((response) => response.json())
    .then((response) => {
        if (response.status === 422) {
            showError(thisBtn, response);
            return;
        }
        renderContents(response);
        openSidebar();
    })
    .catch((e) => {
        console.error(e);
    })
  }
  
  // Silent refresh - updates cart contents without opening the sidecart drawer
  window.refreshSideCartSilent = function() {
    const config = fetchConfig('javascript');
    config.body = JSON.stringify({
        sections: getSectionsToRender().map((section) => section.id),
        sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_update_url}`, config)
    .then((response) => response.json())
    .then((response) => {
        if (response.status === 422) {
            return;
        }
        renderContents(response);
        // Note: Not calling openSidebar() - silent update only
    })
    .catch((e) => {
        console.error(e);
    })
  }

  // CLICK EVENTS
  document.addEventListener('DOMContentLoaded', () => {

    document.addEventListener('click', (e) => {
      if ((e.target.id.includes('appointo-confirm') || e.target.id.includes('appointo-next')) && e.target.innerText.toLowerCase() === 'add to cart') {
        setTimeout(() => {
          updateSideCart();
          document.body.classList.remove('appointo-fixed');
        }, 1000);
      }
    });

    // open sidecart
    const cartBtn = document.querySelector(selectors.headerCartButton);
    if (cartBtn) {
      cartBtn.addEventListener('click', (e) => {
        openSidebar(e);
      })
    }

    // close sidecart
    const closeEl = document.querySelectorAll(selectors.closeSidebarElement);
    if (closeEl !== undefined) {
      closeEl.forEach((el) => {
        el.addEventListener('click', (e) => {
          closeSidebar(e);
        })
      })
    }

    // open/close order note
    const orderNoteBtns = document.querySelectorAll([selectors.orderNoteOpen, selectors.orderNoteClose]);
    if (orderNoteBtns) {
      orderNoteBtns.forEach((el) => {
        el.addEventListener('click', (e) => {
          document.querySelector(selectors.sidebarContainer).classList.toggle('order-note-opened');
        })
      })
    }

    function handleAddToCard(e) {
      if (e.target.hasAttribute(selectors.addToSidecart) || (e.target.closest('button') && e.target.closest('button').hasAttribute(selectors.addToSidecart))) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        addProduct(e.target.hasAttribute(selectors.addToSidecart) ? e.target : e.target.closest('button'));
      }
    }

    function handleRemoveFromCart(e) {
      if (e.target.hasAttribute(selectors.removeProduct) || (e.target.closest('button') && e.target.closest('button').hasAttribute(selectors.removeProduct))) {
        removeProduct(e.target.closest('.sidecart-item'));
      }
    }

    function handleSaveCartNote(e) {
      if (e.target.classList.contains('custom-sidecart__ordernote-save')) {
        const noteField = document.querySelector('.custom-sidecart-ordernote__textarea');
        if (noteField ) {
          const body = JSON.stringify({ note: noteField.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }
      }
    }

    document.addEventListener('click', handleAddToCard);
    document.addEventListener('click', handleRemoveFromCart);
    document.addEventListener('click', handleSaveCartNote);
  });
})();
